export const BookingScreens = {
  SLOTS: 'SLOTS',
  LOADING: 'LOADING',
  LICENSE_TYPE: 'LICENSE_TYPE',
  USER_INFO: 'USER_INFO',
  REGISTRATION_TABS: 'REGISTRATION_TABS',
  BOOKING_ERROR: 'BOOKING_ERROR',
};
